export async function transitionLoader() {
    await timeout(300);
    return true;
}

function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
}